import * as React from "react";
import { getData, Product } from "../db";
import { produce } from "immer";

export type Action =
  | {
      type: "selectOption";
      groupIndex: number;
      accessoryIndex: number;
      optionIndex: number;
      b?: boolean;
      codes?: string[];
    }
  | {
      type: "setOption";
      groupIndex: number;
      accessoryIndex: number;
      optionIndex: number;
      b?: boolean;
      codes?: string[];
    }
  | {
      type: "setOptions";
      groupIndex: number;
      accessoryIndex: number;
      optionIndex: number;
      b?: boolean;
      codes?: string[];
    };

function appReducer(state: Product, action: Action): Product {
  const { groupIndex, accessoryIndex, optionIndex } = action;
  return produce(state, (draft) => {
    switch (action.type) {
      case "selectOption":
        draft.groups[groupIndex].accessories[accessoryIndex].options.forEach((option, n) => {
          option.selected = n === optionIndex;
        });
        break;
      case "setOption":
        draft.groups[groupIndex].accessories[accessoryIndex].options[optionIndex].selected = !!action.b;
        break;
      case "setOptions":
        draft.groups.forEach((g) => {
          g.accessories.forEach((a) => {
            a.options.forEach((o) => {
              if (action.codes!.includes(o.code)) {
                o.selected = !!action.b;
              }
            });
          });
        });
        break;
      default:
        return state;
    }
  });
}

export const appStateContext = React.createContext<Product | undefined>(undefined);
export const appDispatchContext = React.createContext<React.Dispatch<any> | undefined>(undefined);

export interface Props {
  data: any;
  children: React.ReactNode;
}
export default function AppContextProvider({ data, children }: Props) {
  const [state, dispatch] = React.useReducer(appReducer, getData(data));

  return (
    <appStateContext.Provider value={state}>
      <appDispatchContext.Provider value={dispatch}>{children}</appDispatchContext.Provider>
    </appStateContext.Provider>
  );
}

export function useProductState() {
  const context = React.useContext(appStateContext);
  if (context === undefined) {
    throw new Error("useProductState must be used within a AppContextProdivder");
  }
  return context;
}

export function useProductDispatch() {
  const context = React.useContext(appDispatchContext);
  if (context === undefined) {
    throw new Error("useProductDispatch must be used within a AppContextProdivder");
  }
  return context;
}
